var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.hasError)?_c('l2qr-not-found'):(_vm.isPaused)?_c('l2qr-paused-qr-code'):(_vm.qrCode)?_c(_vm.qrCodePageComponent,{tag:"component"}):_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }